import { useSelector } from 'react-redux';
import { PLATE_TYPE, TRANSACTION_TYPE_MAP } from '../docs/constants';
import { selectRefiDocsFormData } from '../../redux-state/selectors';
import { formatDate } from '../utility/formatDate';

function TransactionInfoRefiDoc() {
  const refiDocsFormData = useSelector(selectRefiDocsFormData)

  return (
    <div>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Transaction Information
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {refiDocsFormData.transactionType &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Transaction Type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData? TRANSACTION_TYPE_MAP[refiDocsFormData.transactionType]: ""}
              </div>
            </div>
          }

          {refiDocsFormData?.transactionDate &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Transaction Date:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {formatDate(refiDocsFormData?.transactionDate)}
              </div>
            </div>
          }

          {refiDocsFormData?.plateType &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Plate type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {PLATE_TYPE[refiDocsFormData?.plateType]}
              </div>
            </div>
          }


          {refiDocsFormData?.plateNumber &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Plate Number:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.plateNumber}
              </div>
            </div>
          }

          {refiDocsFormData?.docsFees &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Doc Fees:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.docsFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.insurancePackages &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Insurance package:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.insurancePackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Theft Protection:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Plate Transfer:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {refiDocsFormData?.plateTransfer ? "Yes" : 'No'}
            </div>
          </div>
        </div>

        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {refiDocsFormData?.uploadDate &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Uploaded Date:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {formatDate(refiDocsFormData?.uploadDate)}
              </div>
            </div>
          }

          {refiDocsFormData?.driverCategory &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Driver Category:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.driverCategory}
              </div>
            </div>
          }

          {refiDocsFormData?.basePrice &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Base Price:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
              {Number(refiDocsFormData?.basePrice || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.additionalFees &&
          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Additional Fee:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {Number(refiDocsFormData?.additionalFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
            </div>
          </div>
          }

          {refiDocsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Protection Packages:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.extendedWarranties &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Extended Warranties:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.extendedWarranties || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Military:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {refiDocsFormData?.military? "Yes": "No"}
            </div>
          </div>

          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Lien:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {refiDocsFormData?.lien? "Yes": "No"}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionInfoRefiDoc